<template>
  <Button
    :label="$t('change_stuffing_date')"
    icon="pi pi-pencil"
    class="p-button-warning p-button-sm mr-1"
    @click="onShowEditModal"
  />

  <CustomSidebar
    v-model:visible="showModal"
    position="bottom"
    :dismissable="false"
    :title="$t('change_stuffing_date')"
    class="p-1"
  >
    <template #actions>
      <Button
        icon="pi pi-pencil"
        class="p-button p-button-warning mr-1"
        :label="$t('change_stuffing_date')"
        @click="save()"
      ></Button>
    </template>

    <BlockUI :blocked="blocked">
      <div class="flex" style="width: calc(100% - 2rem)">
        <div class="col-4 md-4 p-fluid">
          <ScrollPanel style="width:100%;height:80vh">
              <ModalData :data="orderData" v-if="orderData"/>
          </ScrollPanel>
        </div>
        <Divider layout="vertical" />
        <div class="col-8 md-4 p-fluid">
          

          <ScrollPanel style="width: 100%; height: 80vh">
            <DataTable
            :loading="!orderData"
            :value="orderData ? orderData.Details : null"
            responsiveLayout="scroll"
            class="p-datatable-sm editable-cells-table"
          >
            <Column
              field="Item_No"
              header="Item No"
              key="Item_No"
              style="width: 10%"
            >
            </Column>
            <Column field="Material_Name" header="Material" key="Material_Name">
            </Column>
            <Column field="Qty" header="Qty" key="Remarks" style="width: 15%">
              <template #body="slotProps">
                <div class="p-fluid">
                  <!-- <InputText v-model="slotProps.data[slotProps.column.props.field]" /> -->
                  <InputNumber
                    v-model="slotProps.data[slotProps.column.props.field]"
                    mode="decimal"
                    :disabled="true"
                    :minFractionDigits="1"
                    :maxFractionDigits="3"
                  />
                </div>
              </template>
            </Column>
            <Column field="UOM" header="UOM" key="Active" style="width: 10%">
            </Column>
          </DataTable>

          <Divider />

            <div class="p-inputtext-sm">
              <div class="field grid">
                <label for="Stuffing_Date" class="col-4 p-p-4">{{
                  $t("stuffing_date")
                }}</label>
                <div class="col-6 md-6">
                  <DatePicker
                    dateFormat="dd/mm/yy"
                    class="p-inputtext-sm"
                    v-model="stuffingDate"
                    selectionMode="range"
                    v-if="orderData"
                    :disabled="true"
                  />
                  <Skeleton v-if="!orderData" />
                </div>
              </div>
              <div class="field grid">
                <label for="Stuffing_Date" class="col-4 p-p-4">{{
                  $t("valid_date")
                }}</label>
                <div class="col-6 md-6">
                  <DatePicker
                    dateFormat="dd/mm/yy"
                    class="p-inputtext-sm"
                    v-model="validDate"
                    selectionMode="range"
                    v-if="orderData"
                    :disabled="true"
                  />
                  <Skeleton v-if="!orderData" />
                </div>
              </div>
              <div class="field grid">
                <label for="Stuffing_Date" class="col-4 p-p-4">{{
                  $t("change_stuffing_date")
                }}</label>
                <div class="col-6 md-6">
                  <DatePicker
                    dateFormat="dd/mm/yy"
                    class="p-inputtext-sm"
                    v-model="newStuffingDate"
                    selectionMode="range"
                    v-if="orderData"
                    :minDate="minDate"
                    :maxDate="maxDate"
                  />
                  <Skeleton v-if="!orderData" />
                </div>
              </div>
            </div>
          </ScrollPanel>
        </div>
      </div>
    </BlockUI>
  </CustomSidebar>
</template>
<script>
import ModalData from "../Helper/_ModalData.vue";

export default {
  components: {
    ModalData: ModalData,
  },
  emits: ["message"],
  props: {
    data: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      showModal: false,
      orderData: null,
      dataUrl: "order/",
      blocked: false,
      newStuffingDate: [],
      stuffingDate: [],
      validDate: [],
    };
  },
  methods: {
    reset() {
      this.orderData = null;
      this.stuffingDate = [];
      this.newStuffingDate = [];
      this.validDate = [];
    },
    save() {
      var self = this
      this.blocked=true
      this.$axios
        .put(this.$API_URL + this.dataUrl + "change_stuffing_date", {
          order_id: this.data[0].Id,
          stuffing_date_from: this.newStuffingDate[0],
          stuffing_date_to: this.newStuffingDate[1],
        })
        .then((response) => {
          console.log(response)
          if(response.data.success){
            self.showModal=false
          self.$toast.add({
            severity: "success",
            summary: "Success",
            detail: "Stuffing date has changed.",
            life: 50000,
          });
          }
          else{
            self.$parent.$toast.add({
            severity: "error",
            summary: "Error",
            detail: response.data.message,
            life: 120000,
          });
          self.blocked = false;
          }
        })
        .catch((err) => {
          self.$parent.$toast.add({
            severity: "error",
            summary: "Error",
            detail: err.message,
            life: 120000,
          });
          self.blocked = false;
        });
    },
    onShowEditModal() {
      this.reset();
      this.showModal = true;

      var self = this;
      this.$axios
        .get(
          this.$API_URL +
            this.dataUrl +
            this.data[0].Id +
            "/" +
            this.$FORM_MODE_EDIT
        )
        .then((response) => {
          if (response.data.success) {
            self.orderData = response.data.data.header;
            self.stuffingDate.push(new Date(self.orderData.Stuffing_Date_From));
            self.stuffingDate.push(new Date(self.orderData.Stuffing_Date_To));
            self.orderData.Valid_From
              ? self.validDate.push(new Date(self.orderData.Valid_From))
              : "";
            self.orderData.Valid_To ? self.validDate.push(new Date(self.orderData.Valid_To)) : "";
          } else {
            self.$parent.$toast.add({
              severity: "error",
              summary: "Error",
              detail: response.data.message,
              life: 120000,
            });
            self.showModal = false;
          }
          self.blocked = false;
        })
        .catch(function (err) {
          self.$parent.$toast.add({
            severity: "error",
            summary: "Error",
            detail: err.message,
            life: 120000,
          });
          self.blocked = false;
          self.showModal = false;
        });
    },
  },
  computed: {
    minDate() {
      return this.validDate.length > 0?this.validDate[0]:null;
      /* 
      var today = new Date()
      return this.validDate.length > 0 &&
        this.$compareDateIsLater(this.validDate[0], today)
        ? this.validDate[0]
        : today; */
    },
    maxDate() {
      return this.validDate.length > 0 ? this.validDate[1] : null;
    },
  },
};
</script>
